import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { MoreVertical } from "lucide-react";
import { useAppDispatch } from "../../../../hooks";
import { setCaseDetailModal } from "../../../../states/slices/globalReducer";
import { useNavigate } from "react-router-dom";

const columnHelper = createColumnHelper<any>();

const ActionCell = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="p-2 text-[#98A2B3] hover:text-[#475467] transition-colors focus:outline-none">
        <MoreVertical className="w-5 h-5" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          anchor="bottom end"
          className="absolute right-0 z-50 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() =>
                    navigate("/registrar1-assessment/case-folders/view")
                  }
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Open folder
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => dispatch(setCaseDetailModal(true))}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  View case details
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Activity log
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  View Join request
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export const Registrar1AssessmentOverviewColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("date", {
    header: "Date",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => (
      <span className="text-[#464255] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => {
      const value = info.getValue();
      let color = "#464255";
      if (value === "Submitted") color = "#00B074";
      return (
        <span style={{ color }} className="font-medium">
          {value}
        </span>
      );
    },
  }),
  columnHelper.accessor("query_status", {
    header: "Query Status",
    cell: (info) => (
      <span className="text-[#464255]">{info.getValue() || "_______"}</span>
    ),
  }),
  columnHelper.accessor("payment", {
    header: "Payment",
    cell: (info) => (
      <span className="text-[#464255]">{info.getValue() || "_______"}</span>
    ),
  }),
  columnHelper.accessor("joinder_request", {
    header: "Joinder request",
    cell: (info) => {
      const value = info.getValue();
      if (!value) return <span className="text-[#464255]">_______</span>;

      return (
        <div className="border border-[#C89500] p-1.5 flex items-center justify-center rounded-full bg-[#E4B11A1A] max-w-fit">
          <span className="text-[#C89500] font-medium text-xs whitespace-nowrap px-2">
            {value}
          </span>
        </div>
      );
    },
  }),
  columnHelper.accessor("assigned_registrar", {
    header: "Assigned Reg.",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("appeal_number", {
    header: "Appeal number",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("time_spent", {
    header: "Time Spent",
    cell: (info) => (
      <span className="text-[#00B074] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.display({
    id: "actions",
    header: "Action",
    cell: () => <ActionCell />,
  }),
];
